// @flow
let sessionStorage;

if (window) {
  ({ sessionStorage } = require('@rover/utilities/storage'));
}

const checkEnvironment = () => {
  if (!sessionStorage) throw new Error('Tried to call sessionStorage outside of a browser.');
};

export const getItem = (key: string) => {
  checkEnvironment();
  return sessionStorage.getItem(key);
};

export const setItem = (key: string, value: string) => {
  checkEnvironment();
  return sessionStorage.setItem(key, value);
};

export const removeItem = (key: string) => {
  checkEnvironment();
  return sessionStorage.removeItem(key);
};

export const clear = () => {
  checkEnvironment();
  return sessionStorage.clear();
};



// WEBPACK FOOTER //
// ../react-lib/src/apis/sessionStorage.api.js